
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/register",
      function () {
        return require("private-next-pages/[locale]/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/register"])
      });
    }
  